import { FascicoloFull } from '../../../../common/models/fascicolo/fascicolo-full';
import { ModalitaPartecipazione } from '../../../../common/models/tipologiche/modalita-partecipazione';


export class FascicoloMediazione extends FascicoloFull {
  modalitaPartecipazione: ModalitaPartecipazione ;
  sedeIncontro: string;
  organismoMediazione: string;
  constructor() {
    super();
    this.dataInizioFascicolo = + new Date();
  }
}
